<template>
  <div class="ui padded attached segment" id="content">
    <!--<div class="ui huge green message" style="text-align: center">
      <div class="header">
        L’école est ouverte et les cours sont assurés jusqu’au 28 juillet 2025
      </div>
      <p>
        Possibilité de prise de contact et renseignements pendant les vacances
        au <a href="tel:+33608647762">06 08 64 77 62</a>.<br />
        Reprise des cours le 1<sup>er</sup> septembre 2025.
      </p>
    </div>-->
    <div class="ui stackable grid">
      <div class="row">
        <div class="eight wide column">
          <img
            src="../assets/images/accueil/cours-de-musique.svg"
            class="ui fluid image"
          />
        </div>
        <div class="eight wide column">
          <h1 class="ui header">Cours de musique</h1>
          <p>
            Venez découvrir, apprendre et jouer sur votre instrument favori
            <strong>à tout âge</strong> ! Nous vous proposerons
            <strong>méthodes et morceaux adaptés</strong> à vos goûts et votre
            niveau. Pour ceux qui le souhaitent, goûtez au
            <strong>plaisir</strong> de participer à un
            <strong>concours</strong>.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="three wide column">
          <img
            src="../assets/images/accueil/instruments.svg"
            class="ui fluid image"
          />
        </div>
        <div class="five wide column">
          <h1 class="ui header">Plusieurs instruments</h1>
          <p>
            Nous vous proposons des cours pour près d’une
            <strong>dizaine d’instruments différents</strong>, et ce
            <strong>quelque soit votre âge et votre niveau</strong>, en
            <strong>cours collectif ou individuel</strong>.
          </p>
        </div>
        <div class="three wide column">
          <img
            src="../assets/images/accueil/carte.svg"
            class="ui fluid image"
          />
        </div>
        <div class="five wide column">
          <h1 class="ui header">Plusieurs villes</h1>
          <p>
            Vous pouvez nous retrouver à <strong>Molsheim</strong>, ainsi qu'à
            <strong>Wisches</strong>.
          </p>
        </div>
      </div>
      <div class="ui divider"></div>
      <div class="centered row">
        <div class="ten wide column">
          <h1 class="ui header center aligned"><strong>Actualités</strong></h1>
          <router-link
            :to="{ name: 'FinalesAMF2025' }"
            style="color: rgba(0, 0, 0, 0.87)"
          >
            <div
              style="background-color: #ddd; padding: 10px; border-radius: 10px"
            >
              <h2 style="font-size: 18px">Finales 2025 à Chaville</h2>
              <p>
                Le 19 octobre 2025 se sont déroulées les Finales du Trophée
                National. Plusieurs élèves de l’école y ont participé, après
                avoir obtenu de bons résultats au concours régional en mai
                dernier. 6 Trophées ont été gagnés par les élèves de l’école. En
                duo guitare, SCHAEFFER Alessia et LARGENTIER Romane ont remporté
                un Trophée pour la 3ème année consécutive. Romane en a également
                gagné un en individuel guitare classique, tout comme MAGLOTT
                Manon. Bravo à SOUCAZE Lisa qui a remporté un trophée en
                individuel piano mais aussi en 4 mains avec sa partenaire
                KARABULUT Azra. Dans la famille FOURGEAUD, un trophée
                supplémentaire pour Anna et Hélène, en piano 4 mains. Un grand
                merci à eux et à tous les autres élèves qui ont participé à ces
                finales 2025 pour leur beau travail !
              </p>
              <button class="ui red button">Voir les résultats</button>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
